module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Canto.6eac445d.png";